<template>
  <div class="setting-detail-container">
    <p class="tips">{{ $t('tips.cash_out_setting_detail') }}</p>

    <div class="flex-justify-between-align-center mt-24">
      <div>
        <span class="setting-detail-label">{{ $t('system.withdraw_type') }}:</span>
        <span class="color-488CE8"> {{ withdrawTypeMapLabel(withdrawInfo.withdraw_type) }}</span>
      </div>
      <div class="setting-detail-opeartion"><el-button type="info" plain class-name="icon-function" style="margin:0;margin-left: 20px;" icon-class="operation-edit" @click="edit">{{ $t('components.edit') }}</el-button>
      </div>
    </div>

    <template v-if="withdrawInfo.withdraw_type === WITHDRAW_TYPE['automatic']">
      <div class="flex-justify-between-align-center mt-24">
        <div>
          <span class="setting-detail-label">{{ $t('merchant.withdrawal_account') }}:</span>
          <span class="color-488CE8">{{ `${bankInfo.settlement_bank}(${bankInfo.settlement_bank_account_num})` }}</span>
        </div>
      </div>
      <div class="flex-justify-between-align-center mt-24">
        <div>
          <span class="setting-detail-label">{{ $t('system.auto_withdraw_type') }}:</span>
          <span class="color-488CE8"> {{ autoWithdrawTypeMapLabel(withdrawInfo.auto_withdraw_type) }}</span>
        </div>
      </div>

      <template v-if="withdrawInfo.auto_withdraw_type === AUTO_WITHDRAW_TYPE['period']">
        <div class="flex-justify-between-align-center mt-24">
          <div>
            <span class="setting-detail-label">{{ $t('data.withdrawal_period') }}:</span>
            <span class="color-488CE8"> D+{{ withdrawInfo.auto_withdraw_dates }}</span>
          </div>
        </div>
        <div class="flex-justify-between-align-center mt-24">
          <div>
            <span class="setting-detail-label">{{ $t('data.next_cash_out_date') }}:</span>
            <span class="color-488CE8"> {{ withdrawInfo.auto_withdraw_next_date }}</span>
          </div>
        </div>
        <div v-if="isCurCountryID" class="flex-justify-between-align-center mt-24">
          <div>
            <span class="setting-detail-label">{{ $t('data.minimum_cash_out_amount') }}:</span>
            <span class="color-488CE8"> {{ withdrawInfo.withdraw_threshold | toDivideWithDot }}
              <span style="font-size: 10px;">( {{ $t('tips.automatic_withdrawal_amount_limit_1') }}{{ withdrawInfo.withdraw_threshold | toDivideWithDot }}{{ $t('tips.automatic_withdrawal_amount_limit_2') }} )</span>
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex-justify-between-align-center mt-24">
          <div>
            <span class="setting-detail-label">{{ $t('data.fixed_amount') }}:</span>
            <span class="color-488CE8">{{ withdrawInfo.auto_withdraw_amount }}</span>
          </div>
        </div>
      </template>

    </template>

    <div v-if="withdraw_fee_status === 1" class="flex-justify-between-align-center mt-24">
      <div>
        <span class="setting-detail-label">{{ $t('system.handling_fee') }}:</span>
        <span class="color-488CE8"> {{ withdraw_fee | toDivideWithDot }} {{ $t('system.per_transaction') }}</span>
      </div>
    </div>

    <ModifyWithdrawMethodModal ref="modifyWithdrawMethodModal" @changeComponent="changeComponent" @submit="getInfo" />
  </div>
</template>

<script>
import { fetchSettlementBank, fetchWithdrawType, fetchNeedSupplementStatus, fetchWithdrawFee } from '@/api/system/system.js'
import { withdrawTypeMap, autoWithdrawTypeMap } from '@/utils/maps'

export default {
  name: 'Cash_Out_Setting',
  components: {
    ModifyWithdrawMethodModal: () => import('./Modal/ModifyWithdrawMethodModal.vue')
  },
  data() {
    this.AUTO_WITHDRAW_TYPE = {
      period: 1,
      fixedAmount: 2
    }
    this.WITHDRAW_TYPE = {
      manually: 1,
      automatic: 2
    }
    return {
      activeName: 'Payment_Needs_Validation',
      isNeedSupplementStatus: false,
      withdrawInfo: {},
      bankInfo: {},
      withdraw_fee: null,
      withdraw_fee_status: null
    }
  },
  computed: {
    isCurCountryID() {
      return this.$store.getters.curCountry.country_code === 'ID'
    },
    withdrawTypeMapLabel() {
      return function(value) {
        return withdrawTypeMap(value).label
      }
    },
    autoWithdrawTypeMapLabel() {
      return function(value) {
        return autoWithdrawTypeMap(value).label
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      // this.getNeedSupplementStatus()
      this.getWithdrawType()
      this.getMchDetail()
      this.getWithdrawFee()
    },
    getWithdrawFee() {
      fetchWithdrawFee().then(res => {
        const { withdraw_fee, withdraw_fee_status } = res.data
        this.withdraw_fee = withdraw_fee
        this.withdraw_fee_status = withdraw_fee_status
        this.$forceUpdate()
      })
    },
    getNeedSupplementStatus() {
      return new Promise((resolve, reject) => {
        fetchNeedSupplementStatus().then(res => {
          const { data } = res
          this.isNeedSupplementStatus = data
          if (data) {
            this.$message.warning('Supplementary information is not passed!')
          }
          resolve(data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { data } = res
        if (data) {
          const { auto_withdraw_amount } = data
          if (auto_withdraw_amount) {
            this.withdrawInfo = { ...data, auto_withdraw_amount: auto_withdraw_amount / 100 }
          } else {
            this.withdrawInfo = data
          }
        }
      })
    },
    getMchDetail() {
      fetchSettlementBank().then(res => {
        if (res.data) {
          this.bankInfo = res.data[0] || {}
        }
      })
    },
    async edit() {
      // if (this.isNeedSupplementStatus) {
      //   this.$message.warning('Supplementary information is not passed!')
      //   return
      // }
      // await this.getNeedSupplementStatus()
      const params = {
        status: true,
        data: JSON.parse(JSON.stringify({ ...this.withdrawInfo, bank_no: this.bankInfo?.bank_no }))
      }
      this.$refs.modifyWithdrawMethodModal.changeModalStatus(params)
    },
    changeComponent(obj) {
      this.$emit('changeComponent', obj)
    }
  }
}
</script>

  <style lang="scss" scoped>
  .setting-detail-container{
    font-size: 14px;
  }
  .setting-detail-label{
    display: inline-block;
    color: #5E6E82;
    min-width: 220px;
    font-weight: 500;
  }
  .setting-item-value{
    display: flex;
    align-items: center;
  }
   .tips {
    color: #364250;
    font-size: 16px;
   }

  </style>
